import { Icon } from '@iconify/react';

// One titled block of the visitor form. The first section drops its top rule so
// the form does not open on a divider.
const FormSection = ({ icon, title, hint, children }) => (
    <section className="tw-pt-4 tw-border-t tw-border-gray-100 first:tw-pt-0 first:tw-border-0">
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
            <Icon icon={icon} className="tw-text-base tw-text-sky-600" />
            <div>
                <h2 className="tw-mb-0 tw-text-xs tw-font-bold tw-text-gray-800">{title}</h2>
                {hint && <p className="tw-mb-0 tw-text-[10px] tw-text-gray-400">{hint}</p>}
            </div>
        </div>
        {children}
    </section>
);

export default FormSection;
